import { useSearchParams, useNavigate } from 'react-router-dom';
import './TossPayment.scss';

const TossFail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code    = searchParams.get('code')    || '';
  const message = searchParams.get('message') || '결제 실패';
  const orderId = searchParams.get('orderId') || '';

  return (
    <div className="toss-result-wrap">
      <h2 className="result-fail">결제에 실패했습니다.</h2>
      <ul className="result-info">
        <li><b>오류코드:</b> {code}</li>
        <li><b>메시지:</b> {message}</li>
        {orderId && <li><b>주문번호:</b> {orderId}</li>}
      </ul>
      <button className="toss-pay-btn" onClick={() => navigate(-1)}>
        뒤로 가기
      </button>
    </div>
  );
};

export default TossFail;
